import DataTableTailwind from "../Components/DataTableTailwind";
import PartialStornoModal from "../Components/PartialStornoModal";
import {printReceipt} from '../Helpers/receipt'
import {useState} from "react";
import {processAxiosError, showError, showSuccess, priceFormat} from "../utils/helper";
import {getPdf} from "../Helpers/pdf";



function SalesIndex() {

    const [processing, setProcessing] = useState(false)
    const [tableKey, setTableKey] = useState(0)

    // Storno confirmation modal
    const [showStornModal, setShowStornModal] = useState(false)
    const [stornSaleItem, setStornSaleItem] = useState(null)

    // Partial storno modal
    const [showPartialStornoModal, setShowPartialStornoModal] = useState(false)
    const [partialStornoSale, setPartialStornoSale] = useState(null)

    const formatColor = function (value, item, name) {

        let color = ''

        if (item.status !== 1) {
            color = 'text-red-600';
        }

        return <span key={'color-' + name + value} className={color}> {value} </span>;

    }

    const formatQuantity = function (value) {

        let color = ''

        if (value > 0) {
            color = 'badge  bg bg-primary';
        } else {
            color = 'badge  bg bg-black';
        }


        return <span key={'name-quantity-' + value} className={color}> {value > 0 ? '+' + value : value} </span>;

    }

    const formatAction = function (value, item) {

        if (value === "add") {
            return 'Dodano'
        } else if (value === "remove") {
            return 'Ulonjeno'
        } else if (value === "transfer") {
            return 'Poslano'
        } else if (value === "transfer-cancel") {
            return 'Slanje otkazano'
        } else {
            return item.id;
        }
    }
    const formatPrice = function (value, item, name) {

        value = value + ' ' + item.invoice_currency_symbol

        return formatColor(value, item, name);

    }
    const formatActions = function (value, item) {


        return (<>
            <button
                onClick={() => printReceipt(item)}
                className="bg-blue-600 hover:bg-blue-800 text-white py-2 px-4 rounded inline-flex items-center">
                <span>Ispis</span>
            </button>
            {!item.fiskal_status && <button
                onClick={() => fiskalateSale(item)}
                className="ml-2 bg-black hover:bg-black-800 text-white py-2 px-4 rounded inline-flex items-center">
                <span>Fiskaliziraj</span>
            </button>
            }

            {item.invoice_real_id && <button
                onClick={() => getPdf(item.invoice_pdf)}
                className="ml-2 bg-green-600 hover:bg-green-800 text-white py-2 px-4 rounded inline-flex items-center">
                <span>PDF</span>
            </button>
            }

            {item.status == 1 &&
            <>
            <button
                onClick={() => { setPartialStornoSale(item); setShowPartialStornoModal(true) }}
                className="ml-2 bg-orange-500 hover:bg-orange-700 text-white py-2 px-4 rounded inline-flex items-center">
                <span>Djelomični storno</span>
            </button>
            <button
                onClick={() => openStornModal(item)}
                className="ml-2 bg-red-600 hover:bg-red-800 text-white py-2 px-4 rounded inline-flex items-center">
                <span>Storniraj</span>
            </button>
            </>
            }

        </>)


    }

    const columns = [
		{name: "id", label: "ID", type: "bigIncrements", formater:formatColor},
        {name: "invoice_date", label: "Datum i vrijeme", type: "timestamp", formater:formatColor},
        {name: "invoice_total_with_tax", label: "Iznos", type: "timestamp", formater:formatPrice},
        {name: "invoice_payment_method", label: "Plaćanje", type: "timestamp", formater:formatColor},
        {name: "invoice_real_id", label: "Broj računa", type: "timestamp", formater:formatColor},
		{name: "action", label: "Akcija", type: "string", formater:formatActions, sortable: false},
    ];

    const actions = [];

    const filters = [];

    const hasCardPayment = (item) => {
        return item.card_gateway_payment_id && !item.card_refunded
    }

    const openStornModal = (item) => {
        setStornSaleItem(item)
        setShowStornModal(true)
    }

    const closeStornModal = () => {
        setShowStornModal(false)
        setStornSaleItem(null)
    }

    const confirmStorn = async () => {
        if (!stornSaleItem) return

        setProcessing(true)
        setShowStornModal(false)

        await window.axios.delete('/sales/' + stornSaleItem.id)
            .then((response) => {
                setProcessing(false)

                if (response.status === 201 && response.data.success === true) {
                    setTableKey(tableKey + 1)

                    if (response.data.card_refund_success) {
                        showSuccess('Račun storniran i povrat na karticu izvršen!')
                    } else if (response.data.card_refund_error) {
                        showError('Račun storniran, ali povrat na karticu nije uspio: ' + response.data.card_refund_error)
                    } else {
                        showSuccess('Račun uspješno stoniran!')
                    }
                } else {
                    showError('Došlo je do greške! Error: ' + response.status)
                }
            })
            .catch((error) => {
                setProcessing(false)
                processAxiosError(error)
            })

        setStornSaleItem(null)
    }

    const fiskalateSale = async (sale) => {
        setProcessing(true)

        await window.axios.post('/sales/' + sale.id + '/fiskalate')
            .then((response) => {
                setProcessing(false)

                if (response.status === 201 && response.data.success === true) {
                    setTableKey(tableKey + 1);
                    showSuccess('Račun uspješno fiskaliziran!')
                } else {
                    showError('Došlo je do greške! Error: ' + response.status)
                }
            })
            .catch((error) => {
                setProcessing(false)
                processAxiosError(error)

            })
    }

    return (
        <div>
            <DataTableTailwind key={'table-sales-' + tableKey} name="sales" url="/sales" columns={columns}
                               filters={filters}
                               actions={actions}/>

            {/* Storno Confirmation Modal */}
            {showStornModal && stornSaleItem && (
                <div className="fixed w-full h-screen left-0 top-0 z-50 flex flex-wrap justify-center content-center p-24">
                    <div onClick={closeStornModal} className="fixed w-full h-screen left-0 top-0 z-0 bg-black bg-opacity-60"></div>
                    <div className="w-96 rounded-lg bg-white shadow-xl overflow-hidden z-10">
                        <div className="p-6">
                            <div className="text-center mb-4">
                                <div className="flex justify-center mb-3">
                                    <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
                                        <svg className="w-7 h-7 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    </div>
                                </div>
                                <h3 className="text-lg font-semibold text-gray-800">Storniranje računa</h3>
                                <p className="text-gray-500 mt-1">Račun #{stornSaleItem.id}</p>
                                <p className="text-xl font-bold text-gray-900 mt-2">{stornSaleItem.invoice_total_with_tax} {stornSaleItem.invoice_currency_symbol}</p>
                            </div>

                            {hasCardPayment(stornSaleItem) && (
                                <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-4">
                                    <div className="flex items-start">
                                        <svg className="w-5 h-5 text-blue-500 mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                                        </svg>
                                        <div>
                                            <p className="text-sm font-semibold text-blue-800">Kartično plaćanje</p>
                                            <p className="text-sm text-blue-600 mt-0.5">Povrat na karticu kupca će se izvršiti automatski.</p>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <p className="text-sm text-gray-500 text-center mb-4">
                                Jeste li sigurni da želite stornirati ovaj račun? Ova radnja se ne može poništiti.
                            </p>

                            <div className="flex gap-2">
                                <button
                                    onClick={closeStornModal}
                                    className="flex-1 py-2.5 px-4 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg font-medium transition-colors"
                                >
                                    Odustani
                                </button>
                                <button
                                    onClick={confirmStorn}
                                    disabled={processing}
                                    className="flex-1 py-2.5 px-4 bg-red-600 hover:bg-red-700 text-white rounded-lg font-medium transition-colors"
                                >
                                    {processing ? 'Procesuiranje...' : 'Storniraj'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <PartialStornoModal
                show={showPartialStornoModal}
                sale={partialStornoSale}
                onSuccess={() => {
                    setShowPartialStornoModal(false)
                    setPartialStornoSale(null)
                    setTableKey(tableKey + 1)
                }}
                onClose={() => {
                    setShowPartialStornoModal(false)
                    setPartialStornoSale(null)
                }}
            />
        </div>
    );


}

export default SalesIndex
